/* RESPONSIBLE TEAM: team-actions */
import Model, { attr } from '@ember-data/model';
import { fragment } from 'ember-data-model-fragments/attributes';

export default class ReportingData extends Model {
  @attr('string') sectionId;
  @attr('array') opportunityFields;
  @fragment('integrations/salesforce/settings') settings;
}
